import { SHOW_ERROR } from "/assets/events/errors.js"
import { HIDE_API_LOADING, SHOW_API_LOADING } from "assets/events/api"
import * as Sentry from "@sentry/browser"

export default defineNuxtPlugin((nuxtApp) => {
	const { $eventBus, $messages } = useNuxtApp()
	const authStore = useAuthStore()
	const toastStore = useToastStore()

	const showLoader = () => {
		$eventBus.$emit(SHOW_API_LOADING)
	}

	const hideLoader = () => {
		$eventBus.$emit(HIDE_API_LOADING)
	}

	const genericErrorHandler = (res, url, requestOptions) => {
		const statusCode = res.statusCode

		let errMsg = ""

		if (statusCode >= 500) {
			logErrorInSentry(res.data, url, requestOptions)
			const errorResponseBody = res.data
			if (typeof errorResponseBody === "object" && !!errorResponseBody.message) {
				$eventBus &&
					$eventBus.$emit(SHOW_ERROR, {
						titleText: $messages.$t("serverError"),
						bodyText: errorResponseBody.message,
					})
			} else {
				$eventBus.$emit(SHOW_ERROR)
			}
		} else if (statusCode >= 400) {
			if (statusCode === 401) {
				authStore.$reset()

				errMsg = $messages.$t("invalidCredentials")
				//Extract the error message from the response if there is one
				const errorResponseBody = res.data
				if (typeof errorResponseBody === "object" && !!errorResponseBody.message) {
					errMsg = errorResponseBody.message
				}
				navigateTo("/login")
			} else if (statusCode === 422) {
				errMsg = parseErrorFromResponse(res.data.errors)
			} else {
				errMsg = res.data.message
			}

			toastStore.setError(errMsg)
			// $eventBus.$emit(SHOW_ERROR, { bodyText: errMsg ?? null })
		} else if (statusCode >= 300) {
		}
	}

	const parseErrorFromResponse = (errorBody) => {
		try {
			return Object.keys(errorBody)
				.map((key) => errorBody[key][0])
				.join("<br>") // Join with \n for new lines
		} catch (e) {
			console.log(e)
			logErrorInSentry(errorBody, null, null)
			return errorBody
		}
	}

	const performRequest = (url, requestOptions, successHandler, errorHandler = genericErrorHandler) => {
		showLoader()

		//Decided to use $fetch api instead of useFetch since all the calls are done on client-side
		//https://nuxt.com/docs/api/utils/dollarfetch
		$fetch(url, {
			...requestOptions,
			headers: {
				...requestOptions.headers,
				"Cache-Control": "no-cache, no-store, must-revalidate",
				Pragma: "no-cache",
				Expires: "0",
			},
			cache: "no-store",
		})
			.then((res) => {
				successHandler && successHandler(res)
			})
			.catch((e) => {
				errorHandler && errorHandler(e, url, requestOptions)
			})
			.finally(hideLoader)
	}

	function maskPasswordsForSentry(requestOptions) {
		if (requestOptions !== null && typeof requestOptions === "object" && !!requestOptions.body) {
			const maskedObj = JSON.parse(JSON.stringify(requestOptions))
			for (const key in maskedObj.body) {
				if (/.*password.*/i.test(key)) {
					maskedObj.body[key] = "***HIDDEN***"
				}
			}
			return maskedObj
		}
		return requestOptions
	}

	const logErrorInSentry = (res, url, requestOptions) => {
		const errorLog = {
			response: res,
			url: url,
			requestOptions: maskPasswordsForSentry(requestOptions),
		}
		//Leave the console log here for Sentry to catch it
		console.log(JSON.stringify(errorLog))
		Sentry.captureMessage(JSON.stringify(errorLog), "error")
	}

	nuxtApp.provide("apiHelper", {
		$showLoader: showLoader,

		$hideLoader: hideLoader,

		$genericErrorHandler: genericErrorHandler,

		$performRequest: performRequest,

		$authedRequestHeader: () => {
			if (authStore.isTokenExpired()) {
				alert("token expired")
				navigateTo("/login")
			}
			authStore.updateExpiresAt()

			return {
				Authorization: `Bearer ${authStore.token}`,
			}
		},
	})
})
